/**
 * Простой логгер для SDK
 * Можно настроить уровень логирования и формат вывода
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
    LogLevel[LogLevel["NONE"] = 4] = "NONE";
})(LogLevel || (LogLevel = {}));
class Logger {
    constructor() {
        this.level = LogLevel.INFO;
        this.prefix = "[FxIdSdk]";
    }
    /**
     * Установить уровень логирования
     */
    setLevel(level) {
        this.level = level;
    }
    /**
     * Установить префикс для логов
     */
    setPrefix(prefix) {
        this.prefix = prefix;
    }
    /**
     * Debug лог
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    debug(message, ...args) {
        if (this.level <= LogLevel.DEBUG) {
            // eslint-disable-next-line no-console
            console.debug(`${this.prefix} ${message}`, ...args);
        }
    }
    /**
     * Info лог
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    info(message, ...args) {
        if (this.level <= LogLevel.INFO) {
            // eslint-disable-next-line no-console
            console.info(`${this.prefix} ${message}`, ...args);
        }
    }
    /**
     * Warning лог
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    warn(message, ...args) {
        if (this.level <= LogLevel.WARN) {
            // eslint-disable-next-line no-console
            console.warn(`${this.prefix} ${message}`, ...args);
        }
    }
    /**
     * Error лог
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error(message, ...args) {
        if (this.level <= LogLevel.ERROR) {
            // eslint-disable-next-line no-console
            console.error(`${this.prefix} ${message}`, ...args);
        }
    }
}
// Экспортируем единственный экземпляр логгера
export const log = new Logger();
// Экспортируем функцию для настройки логгера
export function configureLogger(options) {
    if (options.level !== undefined) {
        log.setLevel(options.level);
    }
    if (options.prefix !== undefined) {
        log.setPrefix(options.prefix);
    }
}
